<div class="shepherd-card">
  <ng-container [ngSwitch]="type">
    <div class="shepherd-card__grid" *ngSwitchCase="SHEPHERD_CARD_TYPES.GRID">
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__grid__column">
        <div></div>
        <div></div>
      </div>
      <div class="shepherd-card__grid__column">
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="shepherd-card__column" *ngSwitchCase="SHEPHERD_CARD_TYPES.COLUMN">
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
    </div>
    <div class="shepherd-card__list" *ngSwitchCase="SHEPHERD_CARD_TYPES.LIST">
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
      <div class="shepherd-card__rectangle"></div>
    </div>
  </ng-container>
</div>
